var DygraphUtils = require('utils/charts/dygraph-trovis');

Dygraph.Plugins.TrovisAnnotation = function () {
    this.markSize = 17;
    this.iconSpace = 2;

    this.cssClass = 'chart-hint';
    this.hints = {};

    var self = this;

    this.activate = function (e) {
        self.g = e;
        e.addAndTrackEvent(e.canvas_, 'mousemove', this.mouseMove);
        return {
            didDrawChart: this.didDrawChart,
        };
    };

    this.toString = function () {
        return 'Trovis Team Dygraph Annotation Plugin';
    };

    this.noteSettings = {
        ok: { color: 'green', icon: '\uF058', prio: 1 },
        info: { color: 'blue', icon: '\uF05A', prio: 1 },
        warn: { color: 'orange', icon: '\uF071', prio: 2 },
        alarm: { color: 'red', icon: '\uF0F3', prio: 3 },
    };

    this.buildAnnotationText = function (a) {
        var texts = {};
        _.each(a.list, function (an) {
            var t = an.text;
            if (texts[t] === undefined) texts[t] = 1;
            else texts[t]++;
        });

        var items = [];
        _.each(texts, function (v, k) {
            items.push(k + (v > 1 ? '(' + v + 'x' + ')' : ''));
        });

        if (items.length > 1) {
            items = _.map(items, function (a) {
                return '<li>' + a + '</li>';
            });
        }

        return items.join(' ');
    };

    this.mouseMove = function (e) {
        if (!self.showIcons) return;

        _.each(self.hints, function (a) {
            a.hintIsVisible = false;
        });

        var ownerWidth = $(self.g.canvas_).width();

        var $canvasParent = $(self.g.canvas_).parent();
        _.each(self.annotationGroups, function (ag) {
            _.each(ag.types, function (v, t) {
                // check if there is mouse over the hint
                var isMouse =
                    v.x <= e.offsetX &&
                    v.x + self.markSize >= e.offsetX &&
                    v.y >= e.offsetY &&
                    v.y - self.markSize <= e.offsetY;
                if (!isMouse) return;

                var key = 'chart-hint' + ag.minX + t;
                if (!self.hints[key]) {
                    var div = document.createElement('div');
                    $canvasParent.append(div);
                    $(div).attr('id', key);
                    self.hints[key] = div;
                }

                // set the content
                var hint = $(self.hints[key]);
                hint.html(self.buildAnnotationText(v));
                hint.addClass(self.cssClass);
                hint.css('color', self.noteSettings[t].color);
                hint.css('border-color', self.noteSettings[t].color);
                hint.css('left', '' + (v.x + self.markSize) + 'px');
                hint.css('top', '' + v.y + 'px');
                hint[0].hintIsVisible = true;

                if (v.x + self.markSize + $(hint).width() > ownerWidth) {
                    hint.css('left', '' + (v.x - self.markSize - $(hint).width()) + 'px');
                }
            });
        });

        var deleteList = [];
        for (var key in self.hints) {
            if (!self.hints[key].hintIsVisible) deleteList.push(key);
        }

        _.each(deleteList, function (k) {
            $(self.hints[k]).remove();
            delete self.hints[k];
        });
    };
};

Dygraph.Plugins.TrovisAnnotation.prototype.didDrawChart = function (e) {
    var self = this;
    var markSize = this.markSize;

    var g = e.dygraph;
    this.annotations = _.filter(g.user_attrs_.annotateEvents, function (a) {
        return a && self.noteSettings[a.type];
    });
    this.showIcons = g.user_attrs_.annotateEventsShowIcons;
    var ctx = e.drawingContext;
    ctx.save();

    var lastGroup = undefined;
    this.annotationGroups = [];
    _.each(this.annotations, function (a) {
        var dx = g.toDomXCoord(a.x);
        if (dx < 0 || dx >= e.canvas.width) return;

        if (lastGroup === undefined || dx > lastGroup.minX + 2 * self.markSize + self.iconSpace) {
            lastGroup = {
                types: {},
                minX: dx,
                maxX: dx,
                colorType: a.type,
            };
            lastGroup.types[a.type] = {
                x: 0,
                y: 0,
                list: [a],
            };
            self.annotationGroups.push(lastGroup);
        } else {
            if (!lastGroup.types[a.type])
                lastGroup.types[a.type] = {
                    x: 0,
                    y: 0,
                    list: [],
                };

            var t = lastGroup.types[a.type];
            t.list.push(a);
            lastGroup.maxX = dx;
            if (self.noteSettings[lastGroup.colorType].prio < self.noteSettings[a.type].prio) {
                lastGroup.colorType = a.type;
            }
        }
    });

    var ownerWidth = $(self.g.canvas_).width();
    // make lines on the average
    _.each(this.annotationGroups, function (ag) {
        ag.realX = (ag.minX + ag.maxX) / 2;

        var color = 'black';
        color = self.noteSettings[ag.colorType].color;

        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.moveTo(ag.realX, 0);
        ctx.lineTo(ag.realX, e.canvas.height);
        ctx.stroke();

        // show icons
        if (g.user_attrs_.isLast) {
            var y = self.markSize;
            _.each(ag.types, function (v, k) {
                v.x = ag.realX + self.iconSpace;
                v.y = y;
                y += self.markSize;

                ctx.font = '14px FontAwesome';
                ctx.fillStyle = self.noteSettings[k].color;
                var note = self.noteSettings[k].icon;
                if (v.x + self.markSize > ownerWidth) {
                    v.x = ag.realX - self.iconSpace - self.markSize;
                }

                ctx.fillText(note, v.x, v.y);
            });
        }
    });

    ctx.restore();
};

Dygraph.PLUGINS.push(Dygraph.Plugins.TrovisAnnotation);
DygraphUtils.addOptions([
    {
        name: 'annotateEvents',
        default: 'undefined',
        labels: ['annotateEvents'],
        type: 'array',
        description: 'annotateEvents',
    },
    {
        name: 'annotateEventsShowIcons',
        default: 'undefined',
        labels: ['annotateEventsShowIcons'],
        type: 'array',
        description: 'annotateEventsShowIcons',
    },
]);
